type TruncateTextOptions = {
  maxLength?: number
  ellipsis?: string
  preserveWords?: boolean
  returnUndefinedIfEmpty?: boolean
}

export function truncateText(text?: string, options: TruncateTextOptions = {}): string | undefined {
  const { maxLength, ellipsis = "…", preserveWords = false, returnUndefinedIfEmpty = true } = options

  if (text == null) return undefined

  const clean = text.replace(/\s+/g, " ").trim()

  if (!clean) {
    return returnUndefinedIfEmpty ? undefined : ""
  }

  if (!maxLength || maxLength <= 0 || clean.length <= maxLength) {
    return clean
  }

  const safeMaxLength = Math.max(maxLength, ellipsis.length)

  let truncated = clean.slice(0, safeMaxLength - ellipsis.length)

  if (preserveWords) {
    const lastSpace = truncated.lastIndexOf(" ")
    if (lastSpace > 0) {
      truncated = truncated.slice(0, lastSpace)
    }
  }

  return truncated.trimEnd() + ellipsis
}
